$(document).ready(function() {
    var currentPage = 1;
    var variantsPerPage = 20; // Número de variantes por página

    // Mostrar la primera página al cargar la página solo si no hay filtros activos
    if (!$('#load-more').hasClass('filters-active')) {
        showPage(currentPage);
    }

    // Función para mostrar la página especificada de variantes
    function showPage(page) {
        var startIndex = (page - 1) * variantsPerPage;
        var endIndex = page * variantsPerPage;

        // Filtrar solo los productos visibles y ocultar los demás
        $('#AjaxinateContainer .product--root').not('.hide, .show').slice(startIndex, endIndex).fadeIn();

        // Mostrar u ocultar botón "Cargar más" y spinner según corresponda
        if (endIndex >= $('#AjaxinateContainer .product--root').not('.hide, .show').length) {
            $('#load-more').hide().find('.fa-spinner').hide(); // Ocultar botón "Cargar más" y spinner si se alcanza el final
        } else {
            $('#load-more').show().find('.fa-spinner').hide(); // Mostrar botón "Cargar más" y ocultar spinner mientras haya más variantes por mostrar
        }
    }

    // Botón "Cargar más"
    $('#load-more').on('click', function() {
        if (!$(this).hasClass('filters-active')) {
            currentPage++;
            $(this).find('.fa-spinner').show(); // Mostrar spinner al hacer clic en "Cargar más"
            setTimeout(function() {
                showPage(currentPage);
            }, 500);
        }
    });

    // Ocultar productos excepto los primeros 12 al cargar la página solo si no hay filtros activos
    if (!$('#load-more').hasClass('filters-active')) {
        $('#AjaxinateContainer .product--root').not('.hide, .show').slice(variantsPerPage).hide();
    }
});

document.addEventListener("DOMContentLoaded", function() {
    var targetDiv = document.getElementById("block-7");
    
    // Check if the div is empty
    if (targetDiv && targetDiv.innerHTML.trim() === "") {
        // Get the next sibling div
        var nextDiv = targetDiv.nextElementSibling;
        
        // Add class to the next div
        if (nextDiv) {
            nextDiv.classList.add("product-page--block_c"); // Reemplaza "custom-style-class" con el nombre de la clase deseada
        }
    }
});

/*$(document).ready(function() {
  function setMaxHeight() {
      $('.product--image').each(function() {
          var width = $(this).width();
          var maxHeight = width;
          $(this).css('max-height', maxHeight);
      });
  }
  
  setMaxHeight();
  
  $(window).resize(function() {
      setMaxHeight();
  });
});*/